<template>
    <b-overlay :show="busy" rounded="sm">
        <!-- {{ value }} -->
        <b-card class="standardpage border-none ">

            <div class="mt-2 availtable datatable">
                <b-card class="w-100pct mb-2">
                    <b-card-body class="py-0 px-0">

                        <b-tabs class="gridtabs" v-model="tabIndex">
                            <b-tab active>
                                <template #title>
                                    <i :class="journal.icon" class="text-primary mr-1"></i>
                                    {{ value.referenceno }}
                                    <span class="text-warning">&lt;{{ selection.length == 0 ? "new" : "edit"
                                        }}&gt;</span>
                                </template>
                                <p class="py-3 px-0">
                                    <b-row>
                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label-cols="12" label="Transaction Date" label-size="sm">
                                                <b-input-group class="treeselect_all" style="left:95px; top:-13px">
                                                    <i id="date_at" class="fa fa-info-circle text-black"></i>
                                                </b-input-group>
                                                <b-tooltip target="date_at" triggers="hover" placement="top">The date of
                                                    the
                                                    journal
                                                    transaction, default to todays date. Disabled for posted
                                                    transactions
                                                </b-tooltip>
                                                <b-input-group>
                                                    <daterangepicker class="w-auto" size="sm" ref="date_at"
                                                        v-model="date_at" :opens="'right'" :locale-data="locale_data"
                                                        :ranges="false" :showDropdowns="true"
                                                        :single-date-picker="'true'" :disabled="readonly"
                                                        @update="edited = true">
                                                    </daterangepicker>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            :disabled="readonly" @click="date_at = {
                                                                startDate: null,
                                                                endDate: null,
                                                            }
                                                                ">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>

                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="Description" label-for="description" label-cols="12">
                                                <b-input-group class="treeselect_all" style="left:68px; top:-13px">
                                                    <i id="description" class="fa fa-info-circle text-black"></i>
                                                </b-input-group>
                                                <b-tooltip target="description" triggers="hover"
                                                    placement="top">Description
                                                    tooltip</b-tooltip>
                                                <b-input-group>
                                                    <b-form-input type="text" v-model="value.description"
                                                        placeholder="Enter description" size="sm"
                                                        @update="edited = true"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            @click="value.description = ''">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="ReferenceNo" label-for="referenceno" label-cols="12">
                                                <b-input-group class="treeselect_all" style="left:75px; top:-13px">
                                                    <i id="referenceno" class="fa fa-info-circle text-black"></i>
                                                </b-input-group>
                                                <b-tooltip target="referenceno" triggers="hover"
                                                    placement="top">ReferenceNo
                                                    tooltip</b-tooltip>
                                                <b-input-group>
                                                    <b-form-input type="text" v-model="value.referenceno"
                                                        placeholder="Enter referenceno" size="sm"
                                                        :disabled="true"></b-form-input>
                                                    <!-- <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary"
                                                @click="value.referenceno = ''" :readonly="true">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append> -->
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>

                                    </b-row>

                                <div class="mt-0 mb-1 text-center nested availtable datatable smallinputs">

                                    <table class="w-100pct table b-table table-striped table-hover table-sm">
                                        <!-- <tr class="header-dark"> -->
                                        <tr class="header-primary text-white">
                                            <td role="columnheader" scope="col" aria-colindex="1"
                                                class="table-b-table-default text-center w-25px">

                                                <!-- <input id="linesAll" style="height: 15px; margin-top: 2px" type="checkbox"
                :checked="allLinesChecked" @change="linesAll"
                :disabled="value.lines.length == 1 || value.lines.filter(o => o.sale != 'N/A').length == 1" /> -->
                                            </td>
                                            <td colspan="2" class="text-center">Lines </td>
                                            <td> Ledger Account </td>
                                            <td> Description </td>
                                            <!-- <td> BL A/C </td>
        <td> SL A/C </td>
        <td> EventCode </td> -->
                                            <!-- <td id="vatlabel"> VAT <i class="fa fa-info-circle"></i>
        </td>
        <b-tooltip target="vatlabel" triggers="hover" placement="top">Include on VAT return</b-tooltip> -->
                                            <td class="text-right pr-2"> Debit GBP </td>
                                            <td class="text-right pr-2"> Credit GBP </td>
                                        </tr>
                                        <tr>
                                            <td></td>
                                            <td colspan="6"></td>

                                        </tr>
                                        <tbody role="rowgroup">
                                            <tr v-for="(line, index) in lines" :key="index">

                                                <td :id="'lines-del_' + index" class="w-30px"
                                                    style="padding-left:5px !important;">
                                                    <b-input-group class="m-auto w-15px">
                                                        <i class="fa fa-minus-square text-danger font-14px"
                                                            @click="delLine(index + 1)"></i>
                                                        <b-tooltip :target="'lines-del_' + index" placement="top">Del
                                                            line</b-tooltip>
                                                        <!-- <input id="lineCheck" style="height: 12px" type="checkbox" v-model="lines"
                        @click="toggleLine($event, index)" :checked="true" :value="line"
                        :disabled="value.lines.length == 1 || line.fare == 'N/A' || value.lines.filter(o => o.fare != 'N/A').length == 1" /> -->

                                                    </b-input-group>
                                                </td>
                                                <td class="w-30px">
                                                    <span class="small text-primary">{{ index + 1 }}.</span>
                                                </td>
                                                <td class="w-30px">
                                                    <i :class="journal.icon" class="mr-2"></i>
                                                </td>

                                                <td>
                                                    <b-form-group class="">
                                                        <b-input-group>
                                                            <treeselect instanceId="nlcode" type="number"
                                                                v-model="line.nlcode" :clearable="true"
                                                                :options="nlcode_options" :multiple="false"
                                                                class="h-20px" @select="edited = true">
                                                            </treeselect>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </td>

                                                <td class="w-30pct">
                                                    <b-form-group class="mb-3px">
                                                        <b-input-group>
                                                            <b-form-input size="sm" v-model="line.description"
                                                                placeholder="Journal Entry" class="text-right"
                                                                :formatter="nocomma" :disabled="true"></b-form-input>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </td>
                                                <!-- <td class="">
                <b-form-group class="mb-3px">
                    <b-input-group>
                        <treeselect placeholder="Select blac..."
                            searchPromptText="Type at least 3 chars..." v-model="line.blac"
                            :clearable="true" :multiple="false" :async="true"
                            :load-options="treeselect_loadBLAC" :show-count="true"
                            :flatten-search-results="true" :disable-branch-nodes="true"
                            :matchKeys="['id']" search-nested>
                            <div slot="value-label" slot-scope="{ node }">
                                {{ node.raw.id }}
                            </div>
                        </treeselect>
                    </b-input-group>
                </b-form-group>
            </td>
            <td class="">
                <b-form-group class="mb-3px">
                    <b-input-group>

                        <treeselect placeholder="Select slac..."
                            searchPromptText="Type at least 3 chars..." v-model="line.slac"
                            :clearable="true" :multiple="false" :async="true"
                            :load-options="treeselect_loadSLAC" :show-count="true"
                            :flatten-search-results="true" :disable-branch-nodes="true"
                            :matchKeys="['id']" search-nested>
                            <div slot="value-label" slot-scope="{ node }">
                                {{ node.raw.id }}
                            </div>
                        </treeselect>

                    </b-input-group>
                </b-form-group>
            </td>
            <td class="">
                <b-form-group class="mb-3px">
                    <b-input-group>
                        <treeselect placeholder="Select event..."
                            searchPromptText="Type at least 4 chars..." v-model="line.eventcode"
                            :clearable="true" :multiple="false" :async="true"
                            :load-options="treeselect_loadEvent" :show-count="true"
                            :flatten-search-results="true" :disable-branch-nodes="true"
                            :matchKeys="['id']" search-nested @select="treeselect">
                            <div slot="value-label" slot-scope="{ node }">
                                {{ node.raw.id }}
                            </div>
                        </treeselect>

                    </b-input-group>
                </b-form-group>
            </td> -->
                                                <!-- <td class="">

                <b-input-group class="m-auto w-15px">
                    <input id="vatreturn" style="height: 12px" class="z-0" type="checkbox"
                        v-model="line.vatreturn" @click="" :checked="true" />

                </b-input-group>
           </td> -->

                                                <td class="w-10pct">
                                                    <b-form-group class="mb-3px">
                                                        <b-input-group>
                                                            <b-form-input size="sm" v-model="line.debit"
                                                                placeholder="Debit" class="text-right"
                                                                :formatter="nocomma" :disabled="line.credit != '0.00'"
                                                                @change="edited = true"></b-form-input>
                                                            <b-input-group-append>
                                                                <b-button size="sm" variant="outline-secondary"
                                                                    @click="line.debit = '0.00'"
                                                                    :disabled="line.credit != '0.00'">
                                                                    <i class="fa fa-remove"></i>
                                                                </b-button>
                                                            </b-input-group-append>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </td>

                                                <td class="w-10pct">
                                                    <b-form-group class="mb-3px">
                                                        <b-input-group>
                                                            <b-form-input size="sm" v-model="line.credit"
                                                                placeholder="Credit" class="text-right"
                                                                :formatter="nocomma" :disabled="line.debit != '0.00'"
                                                                @change="edited = true"></b-form-input>
                                                            <b-input-group-append>
                                                                <b-button size="sm" variant="outline-secondary"
                                                                    @click="line.credit = '0.00'"
                                                                    :disabled="line.debit != '0.00'">
                                                                    <i class="fa fa-remove"></i>
                                                                </b-button>
                                                            </b-input-group-append>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </td>
                                            </tr>
                                        </tbody>

                                        <tr class="h-30px">
                                            <td :id="'lines-add_' + value.id" class="w-30px">
                                                <i class="fa fa-plus-square text-primary font-14px "
                                                    @click="addLine"></i>
                                                <b-tooltip :target="'lines-add_' + value.id" placement="top">Add
                                                    line</b-tooltip>
                                            </td>

                                            <td colspan="12">
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="pl-1 text-left pt-1 border-top-none" colspan="4">
                                                <!-- <b-row class="mt-2" no-gutters>
                <b-col cols="auto" class="text-left">
                    <b-button size="sm" class="xs line-height-0" :variant="'outline-primary'"
                        @click="saveit" :disabled="value.posted">
                        Save It
                    </b-button>
                </b-col>
                <b-col class="text-left ml-2 mt-0">
                    <div v-if="busy">
                        <i class="fa fa-spinner fa-spin text-primary"></i>
                    </div>
                    <div v-else>
                        <span v-html="message_saveit"></span>
                    </div>
                </b-col>
            </b-row> -->
                                            </td>


                                            <td class="pr-1 text-right border-top-none"><span
                                                    class="h6 strong">Total</span></td>
                                            <td class="border-top-none">
                                                <b-form-group class="mb-3px">
                                                    <b-input-group>
                                                        <b-form-input size="sm" v-model="debit" placeholder="Debit"
                                                            class="text-right strong" :disabled="true"
                                                            :formatter="nocomma"></b-form-input>
                                                        <b-input-group-append>
                                                            <b-button size="sm" variant="outline-secondary"
                                                                @click="line.debit = '0.00'" :disabled="true">
                                                                <i class="fa fa-remove"></i>
                                                            </b-button>
                                                        </b-input-group-append>
                                                    </b-input-group>

                                                </b-form-group>
                                            </td>
                                            <td class="border-top-none">
                                                <b-form-group class="mb-3px">
                                                    <b-input-group>
                                                        <b-form-input size="sm" v-model="credit" placeholder="Credit"
                                                            class="text-right strong" :disabled="true"
                                                            :formatter="nocomma"></b-form-input>
                                                        <b-input-group-append>
                                                            <b-button size="sm" variant="outline-secondary"
                                                                @click="line.debit = '0.00'" :disabled="true">
                                                                <i class="fa fa-remove"></i>
                                                            </b-button>
                                                        </b-input-group-append>
                                                    </b-input-group>

                                                </b-form-group>
                                            </td>
                                            <td class="border-top-none"></td>
                                        </tr>

                                    </table>
                                    <b-row no-gutters>
                                        <b-col v-if="total == 0">
                                            <b-alert :show="!total == 0" variant="success">
                                                <b-row align-v="center" no-gutters><b-col cols="auto mr-3">
                                                        <i class="fa fa-check-circle-o fa-2x"></i></b-col>
                                                    <b-col>
                                                        The sum of the debits and credits equal <span class="h6 strong"
                                                            v-html="total"></span></b-col></b-row>
                                            </b-alert>


                                        </b-col>
                                        <b-col v-else>
                                            <b-alert :show="!total == 0" variant="danger">
                                                <b-row align-v="center" no-gutters><b-col cols="auto mr-3">
                                                        <i class="fa fa-close fa-2x"></i></b-col>
                                                    <b-col>
                                                        The sum of the debits and credits must equal. There is a
                                                        difference of <span class="h6 strong"
                                                            v-html="total"></span>.</b-col></b-row>
                                            </b-alert>
                                        </b-col>
                                    </b-row>
                                    <!-- {{value}} -->
                                    <b-row no-gutters>
                                        <b-col cols="auto" class="mr-3">
                                            <b-button squared size="sm" variant="primary" @click="saveit"
                                                v-if="user.permissions.includes('journals.save')"
                                                :disabled="postit_disabled">
                                                <i class="fa fa-check"></i>
                                                Post It
                                            </b-button>
                                        </b-col>
                                        <b-col class="text-left my-auto">
                                            <div v-if="busy">
                                                <i class="fa fa-spinner fa-spin text-primary"></i>
                                            </div>
                                            <div v-else>
                                                <span v-html="message"></span>
                                            </div>
                                        </b-col>
                                    </b-row>

                                </div>
                                </p>
                            </b-tab>

                            <b-tab>
                                <template #title>
                                    <i class="fa fa-history text-primary mr-1"></i>Audit
                                </template>

                                <p class="py-3 px-0">
                                    <!-- <b-row>
                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="ID" label-for="id" label-cols="12">
                                                <b-input-group>
                                                    <b-form-input type="text" v-model="value.id" placeholder="" size="sm"
                                                        :disabled="true"></b-form-input>

                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>

                                    </b-row>                             -->
                                    <b-row>
                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="Created At" label-for="created_at" label-cols="12">
                                                <b-input-group>
                                                    <b-input-group-prepend>
                                                        <b-form-datepicker size="sm" v-model="value.created_at"
                                                            button-only label-help="" locale="en-GB"
                                                            :disabled="true"></b-form-datepicker>
                                                    </b-input-group-prepend>
                                                    <b-form-input size="sm" id="date" v-model="value.created_at"
                                                        type="text" placeholder="YYYY-MM-DD" autocomplete="off"
                                                        :disabled="true"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            @click="value.created_at = null" :disabled="true">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="Created By" label-for="created_by" label-cols="12">
                                                <b-input-group>
                                                    <b-form-input type="text" v-model="value.created_by" placeholder=""
                                                        size="sm" :disabled="true"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            @click="value.created_by = ''" :disabled="true">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="Updated At" label-for="updated_at" label-cols="12">
                                                <b-input-group>
                                                    <b-input-group-prepend>
                                                        <b-form-datepicker size="sm" v-model="value.updated_at"
                                                            button-only label-help="" locale="en-GB"
                                                            :disabled="true"></b-form-datepicker>
                                                    </b-input-group-prepend>
                                                    <b-form-input size="sm" id="date" v-model="value.updated_at"
                                                        type="text" placeholder="YYYY-MM-DD" autocomplete="off"
                                                        :disabled="true"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            @click="value.updated_at = null" :disabled="true">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="Updated By" label-for="updated_by" label-cols="12">
                                                <b-input-group>
                                                    <b-form-input type="text" v-model="value.updated_by" placeholder=""
                                                        size="sm" :disabled="true"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            @click="value.updated_by = ''" :disabled="true">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                </p>
                            </b-tab>

                        </b-tabs>

                    </b-card-body>
                </b-card>

            </div>

            <!-- <b-row style="margin-bottom:-8px;">
                <b-col>
                    <b-button-group class="z-0">
                        <b-row align-h="start" no-gutters>
                            <b-col class="gridtoolbar" cols="auto" v-for="(tool, index) in journal.toolbarlibrary.filter(
                                (o) => o.position == 'toolbar'
                            )" :key="index">
                                <b-button v-if="tool.type == 'button'" :id="'tool_' + tool.action" :size="tool.size"
                                    :variant="tool.variant" :title="tool.title ? tool.title : toolLabel(tool)"
                                    :squared="tool.squared ? 'squared' : null" :disabled="toolDisabled(tool.action)"
                                    @click="toolClick(tool.action)">
                                    <i v-if="toolIcon(tool)" :class="toolIcon(tool)"></i>
                                    <span v-if="toolLabel(tool)" v-html="toolLabel(tool)">
                                    </span>
                                    <i v-if="tool.icon2" :class="tool.icon2"></i>
                                </b-button>
                            </b-col>
                        </b-row>
                    </b-button-group>
                </b-col>
            </b-row> -->

            <!-- {{ lines }} -->
            <b-card-footer class="mt-2 ml-1">
                <b-row>
                    <b-col class="text-right">
                        <b-button squared size="sm" variant="secondary" @click="$emit('discard')">
                            <i class="fa fa-chevron-left pr-1"></i>Back
                        </b-button>
                    </b-col>
                </b-row>
            </b-card-footer>
        </b-card>
    </b-overlay>
</template>

<script>
import gql from "graphql-tag";

export default {
    name: "JournalEdit",
    props: {
        value: { type: Object, required: true },
    },
    watch: {
        value: {
            immediate: true,
            async handler(newVal, oldVal) {
                let date_at = this.$moment.unix(newVal.date_at * 0.001).utc(true).format("YYYY-MM-DD")
                this.date_at = { startDate: date_at, endDate: date_at }
                this.description = newVal.description
                this.lines = newVal.items
                this.edited = false
            }
        },
        lines: {
            immediate: true,
            deep: true,
            async handler(newVal, oldVal) {
                this.postit_ready()
            }
        },
        date_at: {
            immediate: true,
            async handler(newVal, oldVal) {
                this.value.date_at = (this.$moment(this.date_at.startDate).utc(true).unix() * 1000).toString()
                this.postit_ready()
            }
        },
        "value.description": {
            immediate: true,
            async handler(newVal, oldVal) {
                this.postit_ready()
            }
        }
    },
    async mounted() {
        try {
            const response = await this.$apollo.query({
                query: gql`
                query nlcodes {
                nlcodes {
                    id
                    label
                }
                }
            `,
            });
            this.nlcode_options = response.data.nlcodes;
        } catch (error) {
            console.log(error);
        }
    },
    data() {
        return {
            busy: false,
            tabIndex: 0,
            edited: false,
            // posted: false,
            readonly: false,
            postit_disabled: true,
            message: "",
            date_at: {
                startDate: this.$moment().format("YYYY-MM-DD"),
                endDate: this.$moment().format("YYYY-MM-DD"),
            },
            nlcode_options: [],
            lines: [],
            journal: {
                icon: "fa fa-pencil-square-o text-secondary",
                debounce: 500,
                toolbarlibrary: [{
                    type: "button",
                    size: "sm",
                    variant: "outline-white",
                    squared: "squared",
                    icon: "fa fa-play text-primary",
                    position: "toolbar",
                    action: "refresh",
                    label: "Go",
                },
                {
                    type: "button",
                    size: "sm",
                    variant: "outline-white",
                    squared: "squared",
                    icon: "fa fa-filter text-primary",
                    position: "toolbar",
                    action: "filter",
                    label: "Filter",
                    component: {
                        name: "",
                    },
                },],
            },
            debit: "0.00",
            credit: "0.00",
            total: "0.00"
        };
    },
    methods: {
        onlyascii(value) {
            // A SPECIFIC REPLACE
            value = value.split('b').join('')
            value = value.normalize('NFD').replace(/([\u0300-\u036f]|[^\x20-\x7E])/g, '')
            return value
        },
        linesAll(evt) {
            const list = this.allLinesChecked
                ? []
                : this.value.lines.slice(0, this.value.lines.length);
            this.lines = list;
        },
        toggleLine(evt, index) {
            console.log("toggleLine", evt, index);

            const savedIndex = this.savedIndex;
            this.savedIndex = index;

            // If this is the first pass or no shift key was
            // pressed, just bail.
            if (savedIndex === null || !evt.shiftKey) return;

            // Shift-clicked the same message :-/
            if (index === savedIndex) return;

            // Get the subset of the message list between the
            // two indicies.
            // console.time("toggle range");
            const subset = this.items.slice(
                Math.min(index, savedIndex),
                Math.max(index, savedIndex) + 1
            );
            // Determine the operation based on the checked state
            // of the clicked checkbox.
            const toggleFn = evt.currentTarget.checked
                ? addCheckedSubset
                : removeCheckedSubset;

            this.lines = toggleFn(this.lines, subset);
            console.log("these are checked", this.lines);
            // console.timeEnd("toggle range");
        },
        addLine() {
            let _copy = { ...this.lines[this.lines.length - 1] }
            _copy.id = null
            _copy.nlcode = null
            _copy.credit = (0).toFixed(2)
            _copy.debit = (0).toFixed(2)
            this.lines.push(_copy)
            this.edited = true
        },
        async delLine(index) {
            if (await this.$bvModal.msgBoxConfirm('Are you sure you want to delete journal line ' + index + '?',
                {
                    title: 'Please confirm delete action.',
                    size: 'md',
                    buttonSize: 'sm',
                    okVariant: 'success',
                    okTitle: 'Yes',
                    cancelTitle: 'No',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })) {

                let result = []
                for (var j = 0; j < this.lines.length; ++j) {
                    if (j != index - 1) {
                        result.push(this.lines[j])
                    }
                }
                this.lines = result
                this.edited = true
            }
        },
        async saveit() {
            console.log('saveit')

            this.busy = true

            let row = this.cleanit({ ...this.value })
            row.items = this.cleanit(this.lines)
            row.items = row.items.filter(o => o.debit != '0.00' || o.credit != '0.00')

            let variables = { rows: [row] };;
            console.log("variables", variables);

            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
                        mutation journals_save(
                            $rows: [Journal_input]
                        ) {
                            journals_save(rows: $rows) {
                                referenceno
                        }
                        }
                    `,
                    variables,
                });

                if (response.data.journals_save.length > 0) {

                    this.value.referenceno = response.data.journals_save[0].referenceno
                }

                this.edited = false
                this.message = "<span class='text-primary'>Saved it.</span>";

            } catch (error) {
                this.message = "<span class='text-danger'>" + error.message + "</span>";
            }

            this.busy = false
        },
        postit_ready() {
            console.log('postit_ready')

            if (!this.date_at.startDate) {
                this.postit_disabled = true
                return
            }

            if (!this.value.description) {
                this.postit_disabled = true
                return
            }

            let debit = 0
            let credit = 0
            for (var k = 0; k < this.lines.length; k++) {
                this.lines[k].date_at = (this.$moment(this.date_at.startDate).utc(true).unix() * 1000).toString()
                this.lines[k].description = this.value.description
                debit += parseFloat(this.lines[k].debit)
                credit += parseFloat(this.lines[k].credit)
            }
            this.debit = (debit).toFixed(2)
            this.credit = (credit).toFixed(2)
            this.total = (Math.abs(credit - debit)).toFixed(2)

            if (this.lines.length > 0) {
                if (this.lines[this.lines.length - 1].nlcode && parseFloat(this.lines[this.lines.length - 1].debit) != 0 || parseFloat(this.lines[this.lines.length - 1].credit) != 0) {
                    this.addLine()
                }
            }

            this.postit_disabled = !this.edited

            if (this.lines.length > 1) {
                if (this.total == '0.00') {
                    this.postit_disabled = false
                }
            }

        }
    },
};
</script>